export const SESSION_PROFILE_KEY = "autotuber_session_profile";

export const AI_VIDEO_PLAN_MODE = Object.freeze({
  BYOK: "BYOK",
  MANAGED: "MANAGED",
  DISABLED: "DISABLED",
});

const PLAN_MODES = new Set(Object.values(AI_VIDEO_PLAN_MODE));
const ROLES = new Set(["USER", "ADMIN", "SUPER_ADMIN"]);

function integerOrNull(value, minimum) {
  return typeof value === "number" && Number.isInteger(value) && value >= minimum ? value : null;
}

function stringOrNull(value, maxLength = 200) {
  return typeof value === "string" && value.trim() && value.trim().length <= maxLength ? value.trim() : null;
}

export function normalizeSessionProfile(value) {
  const source = value && typeof value === "object" ? value : {};
  return {
    id: stringOrNull(source.id),
    username: stringOrNull(source.username),
    role: ROLES.has(source.role) ? source.role : null,
    aiVideoPlanMode: PLAN_MODES.has(source.aiVideoPlanMode) ? source.aiVideoPlanMode : AI_VIDEO_PLAN_MODE.DISABLED,
    aiVideoDailyLimit: integerOrNull(source.aiVideoDailyLimit, -1),
    aiVideoUsedToday: integerOrNull(source.aiVideoUsedToday, 0),
    aiVideoRemainingToday: integerOrNull(source.aiVideoRemainingToday, -1),
  };
}

export function saveSessionProfile(profile) {
  const normalized = normalizeSessionProfile(profile);
  localStorage.setItem(SESSION_PROFILE_KEY, JSON.stringify(normalized));
  return normalized;
}

export function getSessionProfile() {
  try {
    return normalizeSessionProfile(JSON.parse(localStorage.getItem(SESSION_PROFILE_KEY) || "null"));
  } catch (_) {
    return normalizeSessionProfile(null);
  }
}

export function clearSessionProfile() {
  localStorage.removeItem(SESSION_PROFILE_KEY);
}

export function notifyAuthSessionChanged() {
  if (typeof window !== "undefined") window.dispatchEvent(new Event("autotuber-auth-session-changed"));
}

export const canManageOwnAiProviders = (profile) =>
  profile?.role === "SUPER_ADMIN" || profile?.aiVideoPlanMode === AI_VIDEO_PLAN_MODE.BYOK;

export const canAccessAiProviders = (profile) =>
  profile?.role === "ADMIN" || profile?.role === "SUPER_ADMIN" || (profile?.role === "USER" && profile?.aiVideoPlanMode !== AI_VIDEO_PLAN_MODE.MANAGED);

export const canUseAiVideoProjects = (profile) =>
  profile?.role === "ADMIN" || profile?.role === "SUPER_ADMIN"
  || profile?.aiVideoPlanMode === AI_VIDEO_PLAN_MODE.BYOK || profile?.aiVideoPlanMode === AI_VIDEO_PLAN_MODE.MANAGED;
